// extracted by mini-css-extract-plugin
module.exports = {"unpad":"Summary_unpad__2L5Wn","fill":"Summary_fill__Rm4Be","fill2":"Summary_fill2__2OB9X"};